<template>
  <div>
    <div class="form-group" v-if="show">
      <label :for="id" v-html="text"></label>

      <v-jstree
        :allowBatch="autoSelectChildren"
        no-dots
        v-if="options && options.length > 0"
        :multiple="multiple"
        :data="options"
        ref="input-tree"
        text-field-name="label"
        showCheckbox
        @item-click="update()"
      >
        <template slot-scope="_">
          <label :class="getNodeClass(_.model)" :for="id + _.model.id">
            {{ _.model.label }}
          </label>
        </template>
      </v-jstree>
    </div>
  </div>
</template>
<script>
export default {
  name: "volcan-treeview",
  props: {
    value: null,
    text: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    autoSelectChildren: {
      type: Boolean,
      default: true,
    },
    hideUnselected: {
      type: Boolean,
      default: false,
    },
    lvlCollapse: {
      type: Number,
      default: 0,
    },
    options: Array,
  },
  watch: {
    options() {
      this.show = false;
      this.setPropertyArray(this.options, 0);
    },
  },
  data: function () {
    return {
      id: null,
      show: true,
      changed: false,
    };
  },
  beforeUpdate() {
    this.show = true;
    if (this.hideUnselected) {
      $(".node-unchecked").each(function (i, e) {
        $(e).closest("li").remove();
      });

      $(".no-child-checked").each(function (i, e) {
        $(e).closest("li").addClass("tree-leaf");
      });
    }
  },
  beforeMount() {
    this.show = true;
    if (this.options && this.options.length > 0) {
      this.setPropertyArray(this.options, 0);
    }
  },
  mounted() {
    this.id = "input" + this._uid;
  },
  methods: {
    getNodeClass(item) {
      var nodeClass = "";

      if (!item.selected && this.hideUnselected && this.noChildCheck(item)) {
        nodeClass = "node-unchecked";
      }

      if (item.selected && this.hideUnselected && this.noChildCheck(item)) {
        if (nodeClass === "") {
          nodeClass = "no-child-checked";
        } else {
          nodeClass += " no-child-checked";
        }
      }
      return nodeClass;
    },
    noChildCheck(e) {
      return !this.checkIfOneChildSelected(e);
    },
    checkIfOneChildSelected(obj) {
      var selected = false;
      if (obj.children && obj.children.length > 0) {
        obj.children.forEach((item) => {
          if (item.selected || this.checkIfOneChildSelected(item)) {
            selected = true;
          }
        });
      }
      return selected;
    },
    setPropertyArray(array, number) {
      array.forEach((element) => {
        this.setProperty(element, number, array);
        if (element.children) {
          this.setPropertyArray(element.children, number + 1);
        }
      });
    },
    setProperty(item, number, parrentArray) {
      if (!item.selected) {
        item.selected = false;
      }
      var values = this.value.filter((s) => s.id == item.id);

      if (values && values.length > 0) {
        item.selected = true;
      } else {
        item.selected = false;
      }

      if (!item.opened || this.hideUnselected) {
        if (number < this.lvlCollapse) {
          item.opened = true;
        } else {
          item.opened = false;
        }
      }
      if (!item.loading) {
        item.loading = false;
      }
      if (!item.icon) {
        item.icon = "null-icon";
      }
      if (!item.disabled) {
        item.disabled = this.disabled;
      }
    },
    update() {
      if (!this.changed) {
        var elemt = document.getElementsByClassName("detail");
        if (elemt.length > 0) {
          elemt[0].dispatchEvent(new CustomEvent("change"));
        }
        this.changed = true;
      }
      $(this.$refs.changed).trigger("change");
      var array = [];
      this.getAllSelected(array, this.options);
      this.$emit("input", array);
    },
    getAllSelected(array, child) {
      child.forEach((element) => {
        if (element.selected) {
          array.push(element);
        }
        if (element.children) {
          this.getAllSelected(array, element.children);
        }
      });
    },
  },
};
</script>
<style>
.vue-treeselect {
  min-height: 70px !important;
}

.vue-treeselect__input {
  border: none !important;
}

.vue-treeselect__control {
  border: none !important;
}

.vue-treeselect__placeholder {
  margin-top: 5px !important;
}

.input-tree-view {
  height: 13px;
}

.null-icon {
  width: 0px !important;
  height: 0px !important;
}

.hide {
  display: none;
}

.tree-default .tree-disabled.tree-selected {
  background-color: transparent !important;
}

.tree-default .tree-selected {
  background: #e0e0e05e !important;
}
</style>



// WEBPACK FOOTER //
// components/AdminTools/divers/input-treeview.vue